var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoursHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.4545mm",
    height: "149.42mm",
    viewBox: "0 0 7.4545455 149.42343",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-105.89 40.027)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -271.62 -108.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1426.8,
    y: 257.55,
    width: 28.175,
    height: 564.75,
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.84655 0 0 .63944 1132 262.16)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m364.87 220.87 2.0282 6.6495 11.407 224.57-13.435 12.728z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.87 220.87-2.0282 6.6495-11.407 224.57 13.435 12.728z",
    fill: "#333"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoursHand);
export default __webpack_public_path__ + "static/media/hours_hand.32f3a4e0bf63cd0c29d26d78b8c12170.svg";
export { ForwardRef as ReactComponent };